import React from 'react';
import { Box, Typography, Alert } from '@mui/material';

const TransactionPage = () => {
  return (
    <Box p={3}>
      <Typography variant="h4" gutterBottom>
        Transaktionsübersicht
      </Typography>
      <Alert severity="info" sx={{ mt: 2 }}>
        Diese Seite wurde in die zentrale Kontobewegungsverwaltung integriert. 
        Nutzen Sie die Kontobewegungen-Seite für alle Transaktionsfunktionen.
      </Alert>
    </Box>
  );
};

export default TransactionPage;
